const styles = {
  selected: {
    backgroundColor: "primary.main",
    color: "white",
    "&:hover": {
      backgroundColor: "primary.main",
    },
  },
  loadingSkeleton: {
    height: "32px",
    borderRadius: "16px",
  },
};

export default styles;
